import { render } from "./FormCreateCompanyTertiary.vue?vue&type=template&id=47944f8b"
import script from "./FormCreateCompanyTertiary.vue?vue&type=script&lang=js"
export * from "./FormCreateCompanyTertiary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__